var _regeneratorRuntime = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/createClass.js");

/*
  This library leverages the p-retry and p-queue libraries, to create a
  queue with automatic retry.

  The addToQueue() is the main function provided by this library.

  There are three user-configurable parameters:
  - concurrency is number of concurrent processes.
  - attempts is the number of retry attempts before finally throwing an error.
  - retryPeriod is the amount of time to wait between retries, in milliseconds.
*/
// Global npm libraries.
var PQueue = require('p-queue');

var pRetry = require('p-retry');

var RetryQueue = /*#__PURE__*/function () {
  "use strict";

  function RetryQueue() {
    var localConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, RetryQueue);

    // Default values
    var concurrency = 1;
    this.attempts = 5;
    this.retryPeriod = 5000; // Allow user to override defaults

    if (localConfig.concurrency) concurrency = localConfig.concurrency;
    if (localConfig.attempts) this.attempts = localConfig.attempts;
    if (localConfig.retryPeriod) this.retryPeriod = localConfig.retryPeriod; // Encapsulate dependencies

    this.validationQueue = new PQueue({
      concurrency: concurrency
    });
    this.pRetry = pRetry; // Bind 'this' object to subfunctions.

    this.addToQueue = this.addToQueue.bind(this);
    this.retryWrapper = this.retryWrapper.bind(this);
    this.handleValidationError = this.handleValidationError.bind(this);
  } // Add an async function to the queue, and execute it with the input object.


  _createClass(RetryQueue, [{
    key: "addToQueue",
    value: function () {
      var _addToQueue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(funcHandle, inputObj) {
        var _this = this;

        var returnVal;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (funcHandle) {
                  _context.next = 3;
                  break;
                }

                throw new Error('function handler is required');

              case 3:
                if (inputObj) {
                  _context.next = 5;
                  break;
                }

                throw new Error('input object is required');

              case 5:
                _context.next = 7;
                return this.validationQueue.add(function () {
                  return _this.retryWrapper(funcHandle, inputObj);
                });

              case 7:
                returnVal = _context.sent;
                return _context.abrupt("return", returnVal);

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);
                console.error('Error in addToQueue(): ', _context.t0);
                throw _context.t0;

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 11]]);
      }));

      function addToQueue(_x, _x2) {
        return _addToQueue.apply(this, arguments);
      }

      return addToQueue;
    }() // Wrap the p-retry library.
    // This function returns a promise that will resolve to the output of the
    // function 'funcHandle'.

  }, {
    key: "retryWrapper",
    value: function () {
      var _retryWrapper = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(funcHandle, inputObj) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                if (funcHandle) {
                  _context3.next = 3;
                  break;
                }

                throw new Error('function handler is required');

              case 3:
                if (inputObj) {
                  _context3.next = 5;
                  break;
                }

                throw new Error('input object is required');

              case 5:
                return _context3.abrupt("return", this.pRetry( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return funcHandle(inputObj);

                        case 2:
                          return _context2.abrupt("return", _context2.sent);

                        case 3:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                })), {
                  onFailedAttempt: this.handleValidationError,
                  retries: this.attempts // Retry 5 times

                }));

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);
                console.error('Error in retryWrapper(): ', _context3.t0);
                throw _context3.t0;

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 8]]);
      }));

      function retryWrapper(_x3, _x4) {
        return _retryWrapper.apply(this, arguments);
      }

      return retryWrapper;
    }() // Notifies the user that an error occured and that a retry will be attempted.
    // It tracks the number of retries until it fails.

  }, {
    key: "handleValidationError",
    value: function () {
      var _handleValidationError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(error) {
        var errorMsg, SLEEP_TIME;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                console.log('Error object: ', error);
                errorMsg = "Attempt ".concat(error.attemptNumber, " failed. There are ").concat(error.retriesLeft, " retries left. Waiting before trying again.");
                console.log(errorMsg);
                SLEEP_TIME = this.retryPeriod;
                console.log("Waiting ".concat(SLEEP_TIME, " milliseconds before trying again.\n"));
                _context4.next = 8;
                return this.sleep(SLEEP_TIME);

              case 8:
                _context4.next = 14;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);
                console.error('Error in handleValidationError()');
                throw _context4.t0;

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 10]]);
      }));

      function handleValidationError(_x5) {
        return _handleValidationError.apply(this, arguments);
      }

      return handleValidationError;
    }()
  }, {
    key: "sleep",
    value: function sleep(ms) {
      return new Promise(function (resolve) {
        return setTimeout(resolve, ms);
      });
    }
  }]);

  return RetryQueue;
}(); // export default RetryQueue


module.exports = RetryQueue;